import React from 'react';

const Menu = () => /* @__PURE__ */ React.createElement(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: "19",
    height: "17",
    viewBox: "0 0 19 17",
    fill: "none"
  },
  /* @__PURE__ */ React.createElement("g", { clipPath: "url(#clip0_25937_41102)" }, /* @__PURE__ */ React.createElement(
    "path",
    {
      d: "M1.40039 16.5C1.11706 16.5 0.879727 16.372 0.688394 16.116C0.497061 15.86 0.401061 15.5435 0.400394 15.1666C0.399727 14.7898 0.495727 14.4733 0.688394 14.2173C0.881061 13.9613 1.11839 13.8333 1.40039 13.8333H17.4004C17.6837 13.8333 17.9214 13.9613 18.1134 14.2173C18.3054 14.4733 18.4011 14.7898 18.4004 15.1666C18.3997 15.5435 18.3037 15.8604 18.1124 16.1173C17.9211 16.3742 17.6837 16.5018 17.4004 16.5H1.40039ZM1.40039 9.83332C1.11706 9.83332 0.879727 9.70532 0.688394 9.44932C0.497061 9.19332 0.401061 8.87688 0.400394 8.49999C0.399727 8.1231 0.495727 7.80666 0.688394 7.55066C0.881061 7.29466 1.11839 7.16666 1.40039 7.16666H17.4004C17.6837 7.16666 17.9214 7.29466 18.1134 7.55066C18.3054 7.80666 18.4011 8.1231 18.4004 8.49999C18.3997 8.87688 18.3037 9.19377 18.1124 9.45066C17.9211 9.70755 17.6837 9.8351 17.4004 9.83332H1.40039ZM1.40039 3.16666C1.11706 3.16666 0.879727 3.03866 0.688394 2.78266C0.497061 2.52666 0.401061 2.21022 0.400394 1.83333C0.399727 1.45644 0.495727 1.14 0.688394 0.884C0.881061 0.628 1.11839 0.5 1.40039 0.5H17.4004C17.6837 0.5 17.9214 0.628 18.1134 0.884C18.3054 1.14 18.4011 1.45644 18.4004 1.83333C18.3997 2.21022 18.3037 2.52711 18.1124 2.784C17.9211 3.04089 17.6837 3.16844 17.4004 3.16666H1.40039Z",
      fill: "#F4F4F4"
    }
  )),
  /* @__PURE__ */ React.createElement("defs", null, /* @__PURE__ */ React.createElement("clipPath", { id: "clip0_25937_41102" }, /* @__PURE__ */ React.createElement(
    "rect",
    {
      width: "18",
      height: "16",
      fill: "white",
      transform: "translate(0.400391 0.5)"
    }
  )))
);

export { Menu };
//# sourceMappingURL=Menu.js.map
